import React from 'react';
import { css } from 'emotion';
import '../../assets/fonts/fonts.css';

/* -------------------------------------------------------
    * Carcard Component starts here
----------------------------------------------------------*/

/* global tw */
const styles = {
    header: css`
        ${tw`w-full flex justify-between items-center`};
        // height: 5.9vh;
        height: 9.5488257108vh;
        @media (min-width: 992px){
            height: 9.5488257108vh;
        } 
    `,
    listWrapper: css`
        ${tw`w-full overflow-y-scroll overflow-x-hidden scrolling-touch`};
        background: #111118;
        border-radius: 6px 6px 0 0;
        border-top: 1px solid rgba(170,11,202,0.2);
        height: 91.4511742891vh;
        padding-bottom: 100px;
        box-shadow: 0 -8px 40px rgba(0,0,0,0.5);
        -webkit-overflow-scrolling: touch;
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    `,
    row: css`
        ${tw`w-full flex flex-wrap justify-between items-center px-2 lg:px-6 lg:px-0 -mx-2 mx-auto scrolling-touch`};   
        max-width: 82rem;
        @media (webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi){
            //Retina Specific
            max-width: 75rem;
        }
    `,
    listingRow: css`
        ${tw`flex flex-wrap w-full items-center h-auto`};   
        max-width: 82rem;
        @media (webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi){
            //Retina Specific
            // max-width: 75rem;
        }
    `,
    itineraryBlob: css`
        ${tw`w-full lg:w-1/2 py-0 px-2 lg:py-4`}
        &:hover{
            cursor: pointer;
            background: rgba(170,11,202,0.08);
            border-radius: 6px;
            color: #AA0BCA;
        }
    `,
    fromToLocations: css`
        ${tw`lg:text-2xl text-normal font-bold`}
        color: #F5F5F7;
        letter-spacing: -0.73px;
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    `,
    blackOverlay: css`
        ${tw`fixed z-200 h-screen w-screen overflow-hidden pin-t`};
        background: rgba(0,0,0,0.6);
    `,
    choiceFilterButton: css`
        ${tw`flex items-center px-4 py-2 fixed z-50 pin-b pin-x mx-auto mb-2 md:mb-4 lg:mb-8 justify-between`};
        background: linear-gradient(135deg, #AA0BCA 0%, #5500DB 100%);
        box-shadow: 0 8px 28px rgba(170,11,202,0.4);
        border-radius: 6px;
        transition: all 0.22s ease;
        width: 95vw;
        height: 3.5rem;
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        @media (min-width: 992px){
            width: 33vw;
            height: 5rem;
        }
        &:hover{
            cursor: pointer;
            filter: brightness(1.12);
            transform: translateY(-2px);
        }
        p{
            -webkit-text-fill-color: #F5F5F7;
            color: #F5F5F7;
            ${tw`font-bold uppercase`};
            font-size: 0.8rem;
            @media(min-width: 992px){ font-size: 1rem; }
            span{
                ${tw`block text-sm font-medium normalcase`};
                color: rgba(255,255,255,0.7);
                -webkit-text-fill-color: rgba(255,255,255,0.7);
                font-size: 0.6rem;
                @media(min-width: 992px){ font-size: 0.7rem; }
            }
        }
    `,
    filterButton: css`
        ${tw`flex items-center px-4 py-2 fixed z-50 pin-b pin-x mx-auto mb-2 md:mb-4 lg:mb-8 justify-center align-center`};
        background: #1A1A24;
        border: 1px solid rgba(170,11,202,0.3);
        box-shadow: 0 4px 16px rgba(0,0,0,0.4);
        border-radius: 6px;
        transition: all 0.22s ease;
        width: 15vw;
        height: 15vw;
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        @media (min-width: 992px){
            width: 5vw;
            height: 5vw;
        }
        &:hover{
            cursor: pointer;
            border-color: rgba(170,11,202,0.6);
            filter: brightness(1.15);
        }
        p{
            -webkit-text-fill-color: #AA0BCA;
            color: #AA0BCA;
            ${tw`font-bold uppercase`};
            font-size: 0.8rem;
            @media(min-width: 992px){ font-size: 1rem; }
            span{
                ${tw`block text-sm font-medium normalcase`};
                color: #9898A8;
                -webkit-text-fill-color: #9898A8;
                font-size: 0.6rem;
                @media(min-width: 992px){ font-size: 0.7rem; }
            }
        }
    `,
    filterButtons: css`
        ${tw`flex text-center lg:text-left lg:px-8 mx-2 px-6 py-4 -mx-2 rounded w-1/2 items-center cursor-pointer`};
        background: rgba(170,11,202,0.08);
        border: 1px solid rgba(170,11,202,0.2);
        border-radius: 6px;
        color: #9898A8;
        transition: all 0.18s ease;
        &:hover { background: rgba(170,11,202,0.14); color: #F5F5F7; }
    `,
    bookingForm: css`
        ${tw`items-center flex flex-wrap mt-12 relative w-full overflow-hidden mx-4`};
        background: #1A1A24;
        border: 1px solid rgba(170,11,202,0.2);
        border-radius: 6px;
        box-shadow: 0 6px 24px rgba(0,0,0,0.4);
        height: max-content;
        @media (min-width: 992px){
            height: 38.195302843vh;
        }
    `,
    datePicker: css`
        ${tw`list-reset`};
        li{
            ${tw`my-2 py-2 px-3 cursor-pointer`};
            color: #9898A8;
            border-radius: 6px;
            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
            transition: all 0.15s ease;
            &:hover { background: rgba(170,11,202,0.08); color: #F5F5F7; }
        }
        li.active{
            background: rgba(170,11,202,0.12);
            color: #F5F5F7;
            font-weight: 700;
            border-left: 2px solid #AA0BCA;
        }
    `,
    autocompleteSuggestions: css`
        ${tw`list-reset w-full`};
        li{
            ${tw`py-2 px-3 my-1 font-sans lg:text-lg`};
            color: #9898A8;
            border-radius: 6px;
            transition: all 0.15s ease;
            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
            &:hover { background: rgba(170,11,202,0.1); color: #F5F5F7; }
        }
    `,
    dateTimeScrollWrapper: css`
        ${tw`w-gr1/3 lg:text-2xl mr-6 lg:px-2 py-2 overflow-y-scroll`}; 
        height:30vh;
        -webkit-overflow-scrolling: touch;
        -webkit-mask-image: -webkit-gradient(linear, left 90%,left bottom, 0%(rgba(0,0,0,1)), 25%(rgba(0,0,0,0)),75%(rgba(0,0,0,0)), 100%(rgba(0,0,0,1)))
    `,
    itineraryLine: css`
        ${tw`w-full flex flex-wrap justify-between py-1 lg:py-1 px-6`}
        // border-bottom: 1px solid #F0F2F5;
    `,

}

const CarCard = (props) => {
    let car = props.car;
    let couponApplied, originalPrice, finalPrice, type;
    // console.log(props.car);
    if(typeof props.car === `undefined`){
        return null;
    }
    if (props.car.hasOwnProperty('vendors') && props.car.category === 'SELF DRIVE') {
        type='self';
        if (props.selectedVendor?.couponValue <= 0){
            couponApplied = false;
        }
        else{
            couponApplied = true;
            }    
            originalPrice = Math.round(props.selectedVendor.base_fare).toLocaleString();
            finalPrice = Math.round(props.selectedVendor.discountedValue).toLocaleString();
            let selfVendors = Object.assign([],props.car.vendors);
            // console.log(selfVendors);
            Object.assign(car,{'vendors':selfVendors});
            // console.log(car);
    }
    else {
        type='';
        if (props.selectedVendor?.couponValue <= 0 ){
            couponApplied = false;
        }
        else{
            couponApplied = true;
        }
            originalPrice = Math.round(props.selectedVendor.base_fare).toLocaleString();
            finalPrice = Math.round(props.selectedVendor.discountedValue).toLocaleString();
    }
    // }
    // else {
    //     if (props.selectedVendor?.couponValue <= 0) {
    //         couponApplied = false;
    //     }
    //     else {
    //         couponApplied = true;
    //     }
    //     originalPrice = Math.round(amt).toLocaleString();
    //     finalPrice = Math.round(props.selectedVendor?.discountedValue).toLocaleString();
    // }
    return (
        <div onClick={props.onClick} className={cardStyles.CarCard}>
            {/* Car Image Section */}
            <div className={css`
                ${tw`w-full flex items-center justify-center`};
                background: #1A1A24;
                padding: 1.5rem 1rem 1rem;
            `}>
                <img className={css`
                    height: 8rem;
                    object-fit: contain;
                    max-width: 100%;
                    filter: drop-shadow(0 8px 16px rgba(170,11,202,0.1));
                `} src={props.car.sub_category_url} />
            </div>

            {/* Card Body */}
            <div className={css`
                ${tw`w-full`};
                padding: 1.125rem 1.25rem 1.25rem;
                display: flex;
                flex-direction: column;
                flex: 1;
            `}>
                <h3 className={cardStyles.carName}>{props?.selectedVendor?.account_name !== "Swing Partner" ? props.car.sub_category : props?.selectedVendor?.vehicle_name}</h3>

                {/* Specs badges */}
                <div className={css`
                    ${tw`flex w-full`};
                    flex-wrap: wrap;
                    gap: 0.375rem;
                    margin-top: 0.625rem;
                `}>
                    <div className={css`${tw`flex flex-row flex-wrap`}; gap: 0.375rem;`}>
                        <span className={cardStyles.carSpecs}>{props.car.no_of_seats} seats</span>
                        {props.car.category === "SELF DRIVE" && <span className={cardStyles.carSpecs}>{props.selectedVendor?.gear_type}</span>}
                        {props.car.category === "SELF DRIVE" && <span className={cardStyles.carSpecs}>{props.selectedVendor?.fuel_type}</span>}
                        {/* <span className={cardStyles.carSpecs}>A/C</span> */}
                    </div>
                </div>

                {/* Pricing Section */}
                <div className={css`
                    ${tw`w-full cursor-pointer`};
                    margin-top: auto;
                    padding-top: 1rem;
                    border-top: 1px solid rgba(170, 11, 202, 0.15);
                    margin-top: 1rem;
                `}>
                    <div className={css`${tw`flex items-center justify-between`}`}>
                        <div>
                            <p className={css`
                                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                                font-weight: 800;
                                font-size: 1.375rem;
                                letter-spacing: -0.03em;
                                color: #F5F5F7;
                                line-height: 1;
                            `}>
                                &#8377;{originalPrice}
                            </p>
                            {props.selectedVendor?.hasOwnProperty('package_kms') && <p className={css`
                                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                                font-weight: 500;
                                color: #5A5A6E;
                                font-size: 0.75rem;
                                text-transform: uppercase;
                                letter-spacing: 0.06em;
                                margin-top: 0.25rem;
                            `}>
                                For {props.type !== 'self' ?
                                    props.selectedVendor?.package_kms.toLocaleString() + ' Kms'

                                    : props.selectedVendor.hasOwnProperty('package_kms') ?
                                        ((typeof props.selectedVendor?.package_kms === 'string' ? (props.selectedVendor?.package_kms.includes('kms') || props.selectedVendor?.package_kms.includes('Kms') ? props.selectedVendor?.package_kms : props.selectedVendor?.package_kms + ' Kms')
                                            : props.selectedVendor?.package_kms.toLocaleString()(typeof props.selectedVendor?.package_kms === 'string' && (props.selectedVendor?.package_kms.includes('kms') || props.selectedVendor?.package_kms.includes('Kms')) ? '' : 'Kms')))
                                        : props.myChoizeKms
                                }
                            </p>}
                        </div>

                        <div className={css`
                            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                            font-weight: 500;
                            color: rgba(255,255,255,0.5);
                            font-size: 0.75rem;
                            text-align: right;
                            line-height: 1.4;
                        `}>
                            {props.selectedVendor?.security_deposit &&
                            props.selectedVendor.security_deposit !== "N/A" &&
                            parseInt(props.selectedVendor.security_deposit) > 0 ? (
                                <>
                                    Deposit{" "}
                                    <span className={css`font-weight: 700; color: #F5F5F7;`}>
                                        ₹{props.selectedVendor.security_deposit.toLocaleString()}
                                    </span>
                                </>
                            ) : (
                                props.rentalType == 2 ? <>
                                    Deposit{" "}
                                    <span className={css`font-weight: 700;`}>N/A</span>
                                </> : <></>
                            )}
                        </div>
                    </div>

                    {props.car.category === "SELF DRIVE" && <p className={css`
                        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                        font-weight: 500;
                        color: #5A5A6E;
                        font-size: 0.75rem;
                        margin-top: 0.5rem;
                    `}>Fuel: {props.selectedVendor?.measure_cd.includes('without') ? 'Not Included' : 'Included'}</p>}
                </div>
            </div>
            {/* <div className={css`${tw`mt-5`}`}> */}
                {/* <p className={cardStyles.providedText}>Service Provided By</p> */}
                {/* <div className={css`${tw`flex flex-row items-center justify-between `}`}> */}

                    {/* <div className={css`${tw`flex flex-row items-center justify-between text-left mt-1`}`}>
                        <div className={css`${tw`h-8 mt-2`}`}
                            style={{
                                width: '5rem',
                                backgroundImage: `url(${props.type !== 'self' ? props.selectedVendor?.image_url : props.selectedVendor?.image_url})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                            }}>
                        </div> */}
                        {/* <div className={css`${tw`h-8 mt-2 flex items-center justify-center text-center font-medium text-sm`}`}
                             style={{
                             width: '6rem',
                             whiteSpace: 'nowrap',  
                             overflow: 'hidden',    
                             textOverflow: 'ellipsis'
                                    }}>
                        {props.type !== 'self' ? props.selectedVendor?.account_name : props.selectedVendor?.account_name}
                        </div> */}
                        {/* {props.selectedVendor?.vehicle_owner_business_name && <p style={{ textTransform: "capitalize" }}>{props.selectedVendor?.vehicle_owner_business_name !== "" ? props.selectedVendor?.vehicle_owner_business_name : props.selectedVendor?.vehicle_owner_name}</p>} */}
                        {/* {props.selectedVendor?.vehicle_owner_business_name && <p style={{ textTransform: "capitalize" }}>{props.selectedVendor?.vehicle_owner_business_name}</p>} */}
                        
                        {/* <div className={css`${tw`h-8 w-px bg-grey mx-2`}`} /> */}

                        {/* <p className={css`${tw`w-1/3 -mt-1 text-sm text-black font-medium`}; left: 10%`}>
                            <span className={css`${tw`inline-flex`}`}><img src={require('../SvgComponents/starLabelSvg.svg')} alt="rating" /></span>
                            {props.type !== 'self' ? props.selectedVendor?.rating : props.selectedVendor?.rating}
                        </p> */}
                    {/* </div> */}

                    {/* {props.car.vendors.length > 1 && <div className={cardStyles.lastContainer}>

                        <p className={cardStyles.serviceText}>
                            More Choices
                            </p>
                        <img src={require('../SvgComponents/drop-arrow.svg')} alt="arrow" />
                    </div>} */}

                {/* </div> */}
            {/* </div> */}
            {/* <Link paintDrip to="reviewPage" hex="#AA0BCA" duration={2} className={css`${tw`no-underline absolute pin-t pin-l z-10 h-full w-full`}`}></Link> */}
            { /* <AniLink paintDrip to="/reviewPage/" hex="#AA0BCA" duration={2} className={css`${tw`no-underline absolute pin-t pin-l z-10 h-full w-full`}`}></AniLink> */}
        </div>

    )
};

const cardStyles = {
    CarCard: css`
        ${tw`relative flex flex-col z-0 px-0 py-0`};
        min-height: 0;
        height: auto;
        border-radius: 6px;
        background: #1A1A24;
        border: 1px solid rgba(170, 11, 202, 0.2);
        box-shadow: 0 4px 16px rgba(0,0,0,0.25);
        transition: all 0.28s ease;
        width: 100%;
        box-sizing: border-box;
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        overflow: hidden;
        @media (min-width: 992px){
            width: calc(33.333% - 1rem);
            &:hover{
                cursor: pointer;
                border-color: rgba(170, 11, 202, 0.4);
                transform: translateY(-4px);
                box-shadow: 0 20px 48px rgba(170, 11, 202, 0.2);
                filter: brightness(1.05);
            }
        }
        a:-webkit-any-link {
            color: inherit !important;
        }
    `,
    carImage: css`
        height: 8.5rem;
        @media(min-width: 992px){
            // transform: scale(1.1);
        }
    `,
    carName: css`
        ${tw`ml-0 mb-0`};
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 700;
        color: #F5F5F7;
        letter-spacing: -0.02em;
        font-size: 1.125rem;
        line-height: 1.2;
        @media(min-width: 992px){
            font-size: 1.25rem;
        }
    `,
    reviewText: css`
        ${tw`block`};
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 600;
        color: #6B7280;
        letter-spacing: -0.005em;
        font-size: 0.8125rem;
        margin-left: 5px;
        vertical-align: middle;
        ${'' /* &:after{
            display: inline-block;
            content: "|";
            margin-left: 7.5px;
            
        }
        &:last-child:after{
            opacity: 0;
        } */}
        @media(min-width: 992px){
            font-size: 14px;

        }
    `,
    carSpecs: css`
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 600;
        color: #CB53D1;
        background: rgba(170, 11, 202, 0.1);
        border: 1px solid rgba(170, 11, 202, 0.2);
        border-radius: 4px;
        padding: 0.25rem 0.625rem;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        margin-right: 0.375rem;
        font-size: 0.6875rem;
        margin-left: 0;
        display: inline-block;
        vertical-align: middle;
        ${'' /* &:after{
            display: inline-block;
            content: "|";
            margin-left: 7.5px;
            
        }
        &:last-child:after{
            opacity: 0;
        } */}
        @media(min-width: 992px){
            font-size: 14px;

        }
    `,
    couponText: css`
        ${tw`ml-2 my-2 opacity-40`};
        opacity: 0.4; 
        font-family: 'proxima-nova', ProximaNova-Regular; 
        letter-spacing: -0.23px; 
        font-size: 0.6rem;
        @media (min-width: 992px){
            font-size: 0.6rem;
        }
    
    `,
    serviceText: css`
        ${tw`w-10 text-right`};
        font-family: 'proxima-nova', ProximaNova-Regular; 
        font-size: 0.6rem;
        font-style: normal;
        ${'' /* font-weight: 500; */}
        font-size: 12px;
        line-height: 13px;
        letter-spacing: -0.4px;
        color: #414242;
        mix-blend-mode: normal;
        opacity: 0.5;
        margin-right:1rem;
        ${'' /* margin-left:4rem; */}
    `,
    providedText: css`
    font-family: 'proxima-nova', ProximaNova-Regular; 
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    letter-spacing: -0.4px;

    color: #414242;

    mix-blend-mode: normal;
    opacity: 0.5;
    `,
    lastContainer: css`
    ${tw`flex flex-row items-center justify-between text-right`};
    ${'' /* left:50%; */}
    position: absolute;
    right:10%;
    cursor:pointer;

    `,
}

export default CarCard;

